var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "copy-assets-modal" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "copy-assets-modal",
            "no-close-on-backdrop": "",
            title: _vm.getModalTitle(),
            size: _vm.isImageSaveMode ? "lg" : "xl",
            centered: "",
            scrollable: "",
            "modal-class": _vm.modalClass,
            "body-class": _vm.isImageSaveMode ? "copy-assets-modal__body" : "",
          },
          on: { shown: _vm.handleModalShown, hide: _vm.handleModalHide },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ hide }) {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end w-100" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: { variant: "secondary" },
                          on: {
                            click: function ($event) {
                              return hide()
                            },
                          },
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: _vm.isActionDisabled() || _vm.isCopying,
                          },
                          on: { click: _vm.handleAction },
                        },
                        [
                          _vm.isCopying
                            ? _c(
                                "span",
                                [
                                  _c("b-spinner", {
                                    staticClass: "mr-1",
                                    attrs: { small: "" },
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.getLoadingText()) +
                                      "...\n          "
                                  ),
                                ],
                                1
                              )
                            : _c("span", [
                                _vm._v(_vm._s(_vm.getActionButtonText())),
                              ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm.isImageSaveMode
            ? _c(
                "div",
                { staticClass: "copy-assets-modal__filename mb-3" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "copy-assets-modal__filename-label",
                      attrs: { for: "copy-assets-save-filename" },
                    },
                    [_vm._v("\n        File name\n      ")]
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: {
                      id: "copy-assets-save-filename",
                      placeholder: "Enter file name",
                      disabled: _vm.isCopying,
                    },
                    model: {
                      value: _vm.saveFilename,
                      callback: function ($$v) {
                        _vm.saveFilename =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "saveFilename",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("CopyAssetsDestinationView", {
            ref: "destinationView",
            attrs: {
              "current-folder-id": _vm.currentFolderId,
              "current-tab": _vm.currentTab,
              "is-save-mode": _vm.localMode === "save",
            },
            on: { "folder-selected": _vm.onFolderSelected },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }